export default __webpack_public_path__ + "static/media/iconGoal.396d70e6.png";